import { render, staticRenderFns } from "./accessControlList.vue?vue&type=template&id=3ae57669&scoped=true"
import script from "./accessControlList.vue?vue&type=script&lang=js"
export * from "./accessControlList.vue?vue&type=script&lang=js"
import style0 from "./accessControlList.vue?vue&type=style&index=0&id=3ae57669&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae57669",
  null
  
)

export default component.exports